import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ReferralNoteLayer from "../components/ReferralNoteLayer";

const ReferralNotePage = () => {
  return (
    <>
      <MasterLayout>
        <ReferralNoteLayer />
      </MasterLayout>
    </>
  );
};

export default ReferralNotePage;
